import React, { Component } from 'react';
import { connect } from 'react-redux';
import Link from '../../../shared/Link/Link';
import Button from '../../../shared/Button/Button';

import { primary_s10_l90 } from '../../../shared/lib/colors';
import { jsx, css } from '@emotion/core';

import { login } from '../../../../redux/modules/user';
import { setGuestCheckout } from '../../../../redux/modules/checkout';
import { checkoutStep } from '../../../shared/lib/gaEnhancedEcommerce';

import './Accedi.scss';
import { ga4BeginCheckout } from '../../../shared/lib/ga4EnhancedEcommerce';
import { fkmxBeginCheckout } from '../../../shared/lib/farmakomMetrics';
import { getCartTotalDiscountedCoupon } from '../../../../redux/modules/cart';
import { gtmToGa4BeginCheckout } from '../../../shared/lib/gtmEnhancedEcommerce';

class Accedi extends Component {
  constructor(props) {
    super(props);

    this.state = {
      email: '',
      password: '',
    };
  }

  ///////////////////////////////////
  // GOOGLE ANALYTICS: STEP 2
  gaStep2(cart) {
    const productsGA = cart.map(p => ({
      id: p.code || '',
      name: p.name,
      category: p.categoryName,
      brand: p.brand,
      price: p.price,
      quantity: p.quantity,
    }));
    // SEND EVENT AFTER 1 SEC
    setTimeout(() => {
      checkoutStep(productsGA, 2);
    }, 1000);
  }

  componentDidMount() {
    // GOOGLE ANALYTICS STEP 2
    if (this.props.advancedGa && this.props.cart) {
      this.gaStep2(this.props.cart);
    }
    // SET GUEST CHECKOUT
    this.props.setGuestCheckout(false);
  }

  componentWillReceiveProps(nextProps) {
    // GOOGLE ANALYTICS STEP 2
    if (nextProps.advancedGa && nextProps.cart !== this.props.cart) {
      this.gaStep2(nextProps.cart);
    }

    if (
      !!nextProps.guestCheckout &&
      nextProps.guestCheckout !== this.props.guestCheckout
    ) {
      this.props.router.push('/spedizione');
    }
  }

  changeEmail = event => {
    this.setState({
      email: event.target.value,
    });
  };

  changePassword = event => {
    this.setState({
      password: event.target.value,
    });
  };

  login = async event => {
    event.preventDefault();
    // await this.props.setGuestCheckout(false);
    const hasPrescription = this.props.cart.find(
      product => !!product.prescription
    );

    // GTM BEGIN CHECKOUT
    if (this.props.hasGoogleTagManager) {
      gtmToGa4BeginCheckout(this.props.cart, this.props.cartTotalDiscounted);
    }

    // GA4 BEGIN CHECKOUT
    if (this.props.hasGoogleAnalytics4Advanced) {
      ga4BeginCheckout(this.props.cart, this.props.cartTotalDiscounted);
    }

    // FKMX BEGIN CHECKOUT
    if (this.props.hasFarmakomMetrics) {
      fkmxBeginCheckout(this.props.cart, this.props.cartTotalDiscounted);
    }

    this.props.login(
      { email: this.state.email, password: this.state.password },
      true,
      hasPrescription
    );
  };

  handleGuestCheckout = event => {
    event.preventDefault();

    this.props.setGuestCheckout(true);
  };

  render() {
    const { primaryColor, loginError } = this.props;

    const formStyle = css`
      .form-control {
        &:focus {
          border-color: ${primaryColor};
        }
      }
    `;

    return (
      <div className="accedi">
        <h1>Accedi</h1>

        <form className="center-block" onSubmit={this.login} css={formStyle}>
          <div className="form-group">
            <label>Email</label>
            <input
              type="email"
              className="form-control"
              onChange={this.changeEmail}
            />
          </div>
          <div className="form-group">
            <label>Password</label>
            <input
              type="password"
              className="form-control"
              onChange={this.changePassword}
            />
            <Link
              to="/recupero-password"
              className="help-block"
              onClick={this.props.onCloseLogin}
            >
              Password dimenticata?
            </Link>
          </div>
          {loginError && <div className="error">{loginError}</div>}
          <div className="action">
            <Button
              type="submit"
              className="btn btn-thick btn-primary"
              style={{ width: '20rem' }}
            >
              Accedi
            </Button>
          </div>
          <div className="action">
            <p style={{ fontWeight: 'bold' }}>Non hai ancora un account?</p>

            <Link
              className="btn btn-thick btn-outline"
              to="/registrazione?isCheckout=true"
              style={{ width: '20rem' }}
            >
              Registrati
            </Link>
          </div>
          {this.props.hasGuestCheckout && (
            <>
              <div
                style={{
                  textAlign: 'center',
                  margin: '1rem 0',
                  textAlign: 'center',
                }}
              >
                oppure
              </div>
              <div style={{ textAlign: 'center' }}>
                <Button
                  onClick={this.handleGuestCheckout}
                  style={{
                    fontWeight: 'lighter',
                    backgroundColor: 'transparent',
                    color: 'black',
                    textDecoration: 'underline',
                    border: 'none',
                    cursor: 'pointer',
                  }}
                >
                  Continua come ospite
                </Button>
              </div>
            </>
          )}
        </form>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  loginError: state.user.error,
  cart: state.cart,
  cartTotalDiscounted: getCartTotalDiscountedCoupon(state),
  advancedGa: state.store.data.features.advancedGa,
  hasGuestCheckout: state.store.data.features.hasGuestCheckout,
  primaryColor: state.store.data.loghiTemplate.brandColor,
  guestCheckout: state.checkout.guestCheckout,
  hasGoogleAnalytics4Advanced: !!state.store.data.features
    .hasGoogleAnalytics4Advanced,
  hasGoogleTagManager: !!state.store.data.features.hasGoogleTagManager,
  hasFarmakomMetrics: !!state.store.data.integrazioni.metrics.apiKey,
});

export default connect(mapStateToProps, { login, setGuestCheckout })(Accedi);
